import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Fragment } from 'react';

const sections = [
  {
    title: 'I. УСТАНОВКА УСТРОЙСТВА',
    steps: [
      {
        text: 'Убедитесь, что в месте установки стабильный сигнал Wi-Fi или сотовой сети',
      },
      {
        text: 'Вставьте провода в каналы устройства (нумеруются слева направо: 1 канал — контакты 1–2, 2 канал — контакты 3–4, 3 канал — контакты 5–6):',
        image: '/instructions/setup.png',
      },
    ],
  },
  {
    title: 'II СОЗДАНИЕ КАБИНЕТА',

    steps: [
      {
        text: 'Скачайте и установите приложение:',
        images: [
          { src: '/instructions/qr1.png', title: 'google-store' },
          { src: '/instructions/qr2.png', title: 'apple-store' },
          { src: '/instructions/qr3.png', title: 'ruStore' },
        ],
      },
      {
        text: 'Зарегистрируйтесь, указав действующий e-mail и надежный пароль.',
      },
      {
        text: 'Подтвердите регистрацию через почту.',
      },
    ],
  },
  {
    title: 'III. Добавление устройств',
    steps: [
      { text: 'Зайдите в раздел «Быстрая настройка»' },
      {
        text: 'Добавьте объект и код плательщика (ваш домашний адрес; код плательщика можно найти на квитанциях)',
      },
      {
        text: 'Добавьте контроллер (серийный номер написан на задней стенке Kolibi — введите все буквы и цифры). Выберите интервал передачи данных, например, раз в месяц, 15 числа.',
      },
      {
        text: 'Добавьте счетчики: выберите подтип счетчика, введите серийный номер (указан на самом счетчике), выберите канал, к которому подключены провода, и введите показания счетчика в литрах — все цифры без первых нулей и без запятых. Коэффициент установите равным 10 или в соответствии с паспортом счётчика.',
      },
      { text: 'После этого нажмите «Сохранить настройки».' },
    ],
  },
  {
    title: 'IV ВКЛЮЧЕНИЕ УСТРОЙСТВА',
    steps: [
      { text: 'Вставьте скрепку и подержите, пока не увидите синий светодиод 🔵  🔵:', image: '/instructions/switchOn.png' },
      {
        text: 'Если у вас устройство NB-IoT, оно автоматически найдет сеть и загорится зеленый светодиод 🟢',
      },
      {
        text: 'Если у вас устройство Wi-Fi, то воспользуйтесь подключением по инструкции ниже.',
      },
    ],
  },
  {
    title: 'V Подключение устройства Wi-Fi',
    steps: [
      {
        text: 'Зайдите в подключение и нажмите «Поиск устройств»:',
        image: '/instructions/connecting.jpg',
      },
      {
        text: 'Введите логин и пароль от Wi-Fi. После подключения загорится зеленый светодиод 🟢',
      },
    ],
  },
  {
    title: 'VI. Заключительный этап',
    steps: [
      { text: 'Проверьте передачу данных, откройте кран и пролейте 10 литров, чтобы изменились показания счетчика.' },
      {
        text: 'Активируйте «принудительную отправку показаний» — нажмите и удерживайте кнопку в течение 2 секунд, пока не загорится зелёный светодиод.',
      },
      { text: 'После этого данные обновятся в вашем кабинете.' },
    ],
  },
];

const ShortInstruction = () => {
  return (
    <div className="mx-auto px-4 pb-4 pt-0 sm:px-6">
      <a className="flex justify-end text-orange-400 hover:text-orange-500 pb-3" href="/instructions/instruction.pdf" target="_blank" rel="noopener noreferrer">
        Открыть в PDF
      </a>
      {sections.map((section, i) => (
        <section key={i} className="mb-8">
          <h4 className="text-base font-semibold mb-3 uppercase sm:text-xl">{section.title}:</h4>
          <ol className="list-decimal list-inside space-y-2">
            {section.steps.map((step, idx) => {
              return (
                <Fragment key={idx}>
                  <li className="text-gray-800 sm:text-base text-sm">{step.text}</li>
                  {step.image && <img className={'object-contain m-auto'} src={step.image} alt={section.title} />}
                  {step.images && step.images?.length > 0 && (
                    <div className="flex flex-row gap-2 justify-evenly flex-wrap">
                      {step.images.map(({ title, src }, ind) => {
                        return <img key={ind} className={'object-contain'} src={src} alt={title} />;
                      })}
                    </div>
                  )}
                </Fragment>
              );
            })}
          </ol>
        </section>
      ))}
      <div className={'flex justify-center items-center gap-2 text-green-500 font-semibold'}>
        <CheckCircleIcon />
        <span>Устройство работает!</span>
      </div>
    </div>
  );
};
export default ShortInstruction;
